module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calculator",
    class: {
      calculator_view_compact: _vm.compact,
        calculator_state_form: _vm.viewForm
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.viewForm || !_vm.compact),
      expression: "!viewForm || !compact"
    }],
    staticClass: "calculator__main"
  }, [_c('div', {
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__title"
  }, [_vm._v("Укажите вашу систему налогообложения")]), _vm._v(" "), _c('div', {
    staticClass: "radio-inline-group checkbox-inline-group"
  }, [_c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-radio' + this._uid,
      "value": 1,
      "disabled": _vm.isDisabledUSN()
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.tax),
      callback: function($$v) {
        _vm.tax = $$v
      },
      expression: "tax"
    }
  }, [_vm._v("УСН 6%")]), _vm._v(" "), _c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-radio' + this._uid,
      "value": 2,
      "disabled": _vm.isDisabledUSN()
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.tax),
      callback: function($$v) {
        _vm.tax = $$v
      },
      expression: "tax"
    }
  }, [_vm._v("УСН 15%")]), _vm._v(" "), _c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-radio' + this._uid,
      "value": 3
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.tax),
      callback: function($$v) {
        _vm.tax = $$v
      },
      expression: "tax"
    }
  }, [_vm._v("ОСНО\n        ")]), _vm._v(" "), _c('checkbox', {
    staticClass: "checkbox_large",
    attrs: {
      "name": "zero"
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.zero),
      callback: function($$v) {
        _vm.zero = $$v
      },
      expression: "zero"
    }
  }, [_vm._v("Нулевая отчетность")])], 1)]), _vm._v(" "), (_vm.zero) ? _c('div', {
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__title"
  }, [_vm._v("Укажите форму вашего юр. лица:")]), _vm._v(" "), _c('div', {
    staticClass: "radio-inline-group checkbox-inline-group"
  }, [_c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-legal' + this._uid,
      "value": 1
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.legal),
      callback: function($$v) {
        _vm.legal = $$v
      },
      expression: "legal"
    }
  }, [_vm._v("\n          ИП\n        ")]), _vm._v(" "), _c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-legal' + this._uid,
      "value": 2
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.legal),
      callback: function($$v) {
        _vm.legal = $$v
      },
      expression: "legal"
    }
  }, [_vm._v("\n          ООО\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "calculator__checkbox-option mt-.5"
  }, [_c('checkbox', {
    staticClass: "checkbox_large",
    class: {
      checkbox_align_top: !_vm.compact
    },
    attrs: {
      "name": "team"
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.team),
      callback: function($$v) {
        _vm.team = $$v
      },
      expression: "team"
    }
  }, [_vm._v("\n          С сотрудниками (кол-во сотрудников более одного)\n        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.zero) ? _c('div', {
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__title"
  }, [_vm._v("Выберите тариф:")]), _vm._v(" "), _c('div', {
    staticClass: "radio-inline-group checkbox-inline-group"
  }, [_c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-tariff' + this._uid,
      "value": 1
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.tariff),
      callback: function($$v) {
        _vm.tariff = $$v
      },
      expression: "tariff"
    }
  }, [_c('strong', [_vm._v("«Эконом»")])]), _vm._v(" "), _c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-tariff' + this._uid,
      "value": 2
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.tariff),
      callback: function($$v) {
        _vm.tariff = $$v
      },
      expression: "tariff"
    }
  }, [_c('strong', [_vm._v("«Стандарт»")])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.zero),
      expression: "!zero"
    }],
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__title"
  }, [_vm._v("Количество документов в месяц")]), _vm._v(" "), _c('div', {
    staticClass: "calculator__range calculator-range calculator-range-docs"
  }, [_c('div', {
    staticClass: "calculator-range__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.docsValue),
      expression: "docsValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "pattern": "[0-9]{0,4}",
      "min": "1",
      "max": "9999",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.docsValue,
      "value": (_vm.docsValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.docsValue = _vm._n($event.target.value)
      }, _vm.updateDocs],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.zero),
      expression: "!zero"
    }],
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__title"
  }, [_vm._v("Количество сотрудников компании")]), _vm._v(" "), _c('div', {
    staticClass: "calculator__range calculator-range calculator-range-staff"
  }, [_c('div', {
    staticClass: "calculator-range__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.staff),
      expression: "staff"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "pattern": "[0-9]{0,4}",
      "min": "0",
      "max": "9999",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.staff)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.staff = $event.target.value
      }, _vm.updateStaff]
    }
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.zero),
      expression: "!zero"
    }],
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__title"
  }, [_vm._v("Дополнительно")]), _vm._v(" "), _c('div', {
    class: {
      'row': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "calculator__checkbox-option",
    class: {
      'col-xl-4': !_vm.compact
    }
  }, [_c('checkbox', {
    staticClass: "checkbox_large",
    class: {
      checkbox_align_top: !_vm.compact
    },
    attrs: {
      "name": "opt1"
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.opt1),
      callback: function($$v) {
        _vm.opt1 = $$v
      },
      expression: "opt1"
    }
  }, [_vm._v("\n            Осуществление производственной или строительной деятельности\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "calculator__checkbox-option",
    class: {
      'col-xl-4': !_vm.compact
    }
  }, [_c('checkbox', {
    staticClass: "checkbox_large",
    class: {
      checkbox_align_top: !_vm.compact
    },
    attrs: {
      "name": "opt2"
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.opt2),
      callback: function($$v) {
        _vm.opt2 = $$v
      },
      expression: "opt2"
    }
  }, [_vm._v("\n            Раздельный учёт при наличии нескольких видов деятельности\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "calculator__checkbox-option",
    class: {
      'col-xl-4': !_vm.compact
    }
  }, [_c('checkbox', {
    staticClass: "checkbox_large",
    class: {
      checkbox_align_top: !_vm.compact
    },
    attrs: {
      "name": "opt3"
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.opt3),
      callback: function($$v) {
        _vm.opt3 = $$v
      },
      expression: "opt3"
    }
  }, [_vm._v("\n            Осуществление внешнеэкономической деятельности (ВЭД)\n          ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "calculator__footer"
  }, [_c('div', {
    staticClass: "row row-flex row-flex_center"
  }, [_c('div', {
    class: {
      'col-md-7': _vm.compact,
      'col-md-12': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "calculator__text1"
  }, [_vm._v("Примерная стоимость услуг бухгалтера")]), _vm._v(" "), (_vm.zero && _vm.reportCount) ? _c('div', {
    staticClass: "calculator__text1"
  }, [_vm._v("от " + _vm._s(_vm.reportCount) + " отчётов в квартал")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calculator__cost"
  }, [(_vm.zero) ? _c('i', [_vm._v("От ")]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.sumDisplay))]), _vm._v(" "), (!_vm.contract) ? _c('i', [_vm._v("руб./месяц")]) : _vm._e()])]), _vm._v(" "), (_vm.compact) ? _c('div', {
    staticClass: "col-md-5 text-md-right"
  }, [(!_vm.viewForm) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showForm
    }
  }, [_vm._v("Заказать услуги")]) : _vm._e(), _vm._v(" "), (_vm.viewForm) ? _c('a', {
    staticClass: "calculator__back",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideForm($event)
      }
    }
  }, [_vm._v("Вернуться к калькулятору")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.viewForm || !_vm.compact) ? _c('div', {
    staticClass: "calculator__note"
  }, [_vm._v("\n      Стоимость услуг ориентировочная. Каждая организация имеет свою специфику, поэтому, для точного определения\n      стоимости услуг, необходим предварительный анализ Ваших документов\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.viewForm) ? _c('div', {
    staticClass: "calculator__form form form_loading_main-color",
    class: {
      form_state_status: _vm.form.status !== null,
        form_state_loading: _vm.form.loading
    }
  }, [(_vm.form.loading) ? _c('div', {
    staticClass: "form__loading form-loading form-loading_main-color"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form__form"
  }, [_c('div', {
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__heading h2"
  }, [_vm._v("Заявка на услугу")]), _vm._v(" "), _c('div', {
    staticClass: "calculator__title",
    class: {
      'text-center': !_vm.compact
    }
  }, [_vm._v("\n          Заполните небольшую форму и наш менеджер свяжется с вами в ближайшее время\n        ")]), _vm._v(" "), (!_vm.compact) ? _c('p', {
    staticClass: "calculator__text"
  }, [_vm._v("\n          Вы можете заполнить форму без предварительного расчета и мы сами рассчитаем стоимость ведения вашей бухгалтерии\n        ")]) : _vm._e(), _vm._v(" "), _c('vue-form', {
    attrs: {
      "method": "post",
      "action": "#",
      "data-action": _vm.api,
      "state": _vm.state
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.formSubmit($event)
      }
    }
  }, [_vm._l((_vm.hiddenFields), function(value, name) {
    return _c('input', {
      attrs: {
        "name": name,
        "type": "hidden"
      },
      domProps: {
        "value": value
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "row row-flex"
  }, [_c('div', {
    class: {
      'col-md-6': _vm.compact, 'col-md-4': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.fid('name')
    }
  }, [_vm._v("\n                  Ваше имя "), _c('i', {
    staticClass: "req req_yellow",
    class: {
      req_white: !_vm.compact
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "inputbox__input form-control",
    attrs: {
      "id": _vm.fid('name'),
      "required": "",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.name.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "name"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1)]), _vm._v(" "), (_vm.compact) ? _c('div', {
    class: {
      'col-md-6': _vm.compact, 'col-md-4': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.fid('company')
    }
  }, [_vm._v("Название компании")]), _vm._v(" "), _c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.company),
      expression: "model.company"
    }],
    staticClass: "inputbox__input form-control",
    attrs: {
      "id": _vm.fid('company'),
      "name": "company",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "company", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.company.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "company"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'col-md-6': _vm.compact, 'col-md-4': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.fid('tel')
    }
  }, [_vm._v("\n                  Телефон "), _c('i', {
    staticClass: "req req_yellow",
    class: {
      req_white: !_vm.compact
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.tel),
      expression: "model.tel"
    }],
    staticClass: "inputbox__input-field form-control",
    attrs: {
      "id": _vm.fid('tel'),
      "required": "",
      "name": "tel",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.model.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "tel", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.tel.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "tel"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    class: {
      'col-md-6': _vm.compact, 'col-md-4': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.fid('mail')
    }
  }, [_vm._v("\n                  Email "), (!_vm.compact) ? _c('i', {
    staticClass: "req req_yellow",
    class: {
      req_white: !_vm.compact
    }
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.mail),
      expression: "model.mail"
    }],
    staticClass: "inputbox__input-field form-control",
    attrs: {
      "id": _vm.fid('mail'),
      "required": !_vm.compact,
      "name": "mail",
      "type": "email"
    },
    domProps: {
      "value": (_vm.model.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "mail", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.mail.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "mail"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))]), _vm._v(" "), _c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "email"
    },
    slot: "email"
  }, [_vm._v(_vm._s(_vm.messages.email))])]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    class: {
      'col-md-6': _vm.compact, 'col-md-5 col-lg-8': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "from-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.fid('message')
    }
  }, [_vm._v("Комментарий")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.message),
      expression: "model.message"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.fid('message'),
      "name": "message",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.model.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "message", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "calculator__form-item-last",
    class: {
      'col-md-6': _vm.compact, 'col-md-7 col-lg-4': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note__star",
    class: {
      note__star_white: !_vm.compact
    }
  }, [_vm._v("*")]), _vm._v("\n                — обязательно для заполнения\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('validate', [_c('div', {
    staticClass: "checkbox"
  }, [(_vm.state.$submitted && _vm.state.accept.$invalid) ? _c('field-messages', {
    staticClass: "checkbox__state form-state",
    attrs: {
      "name": "accept"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.accept))])]) : _vm._e(), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.accept),
      expression: "model.accept"
    }],
    attrs: {
      "name": "accept",
      "type": "checkbox",
      "checked": "",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.model.accept) ? _vm._i(_vm.model.accept, null) > -1 : (_vm.model.accept)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.accept,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.accept = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model.accept = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.model, "accept", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("Принимаю "), _c('a', {
    staticClass: "link-dotted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("политику конфиденциальности")]), _vm._v(" и\n                      "), _c('a', {
    staticClass: "link-dotted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("пользовательское соглашение")])])])], 1)])], 1), _vm._v(" "), (_vm.compact) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn calculator__",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.model.accept)
    }
  }, [_vm._v("\n                  Заказать услуги\n                ")])]) : _vm._e()]), _vm._v(" "), (!_vm.compact) ? _c('div', {
    class: {
      'col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4': !_vm.compact
    }
  }, [_c('button', {
    staticClass: "btn btn_block calculator__",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.model.accept)
    }
  }, [_vm._v("\n                Заказать услуги\n              ")])]) : _vm._e()])], 2)], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "status"
    }
  }, [(_vm.form.status !== null) ? _c('form-status', {
    staticClass: "form__status",
    attrs: {
      "theme": !_vm.compact ? 'without-color' : '',
      "status": _vm.form.status,
      "message": _vm.form.message
    },
    on: {
      "close": function($event) {
        _vm.hideStatus();
        _vm.hideForm()
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calculator-range__slider"
  }, [_c('input', {
    staticClass: "ion-range-slider",
    attrs: {
      "type": "hidden",
      "data-model": "docs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calculator-range__slider"
  }, [_c('input', {
    staticClass: "ion-range-slider",
    attrs: {
      "type": "hidden",
      "data-model": "staff"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00d56193", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00d56193","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/Calculator/Calculator.vue
// module id = 95
// module chunks = 0